
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export type ConfirmDialogData = {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: 'primary' | 'accent' | 'warn';
};

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  readonly data = inject(MAT_DIALOG_DATA) as ConfirmDialogData;
  private ref = inject(MatDialogRef<ConfirmDialogComponent>);

  get title() { return this.data.title || 'Confirmare'; }
  get confirmText() { return this.data.confirmText || 'Confirmă'; }
  get cancelText() { return this.data.cancelText || 'Anulează'; }
  get confirmColor() { return this.data.confirmColor || 'primary'; }

  confirm() {
    this.ref.close(true);
  }

  cancel() {
    this.ref.close(false);
  }
}
